import { buildSlice, CommonState } from '~libs/reduxUtils';

import { Supplier } from '~support-at-home/models';

import { getAll, typePrefix } from '~support-at-home/actions/suppliers';

const initialState: CommonState<Supplier> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  total: 0,
};

const slice = buildSlice<CommonState<Supplier>, Supplier>(typePrefix, initialState, {
  extraReducers: (builder) => {
    builder.addCase(getAll.pending, (state) => {
      state.loading = 'pending';
    });
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      const { rows, total } = action.payload.data;
      state.rows = rows;
      state.total = total;
    });
    builder.addCase(getAll.rejected, (state) => {
      state.loading = 'error';
    });
  },
});

export const { clear, updateFile } = slice.actions;
export default slice.reducer;
